var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "20px",
    viewBox: "0 0 36 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telephones icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "2.74468021e-05 0.091765625 13.8923654 0.091765625 13.8923654 20 2.74468021e-05 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "2.74468021e-05 0.091765625 13.8923077 0.091765625 13.8923077 20 2.74468021e-05 20"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Info-Area-WIDE",
    transform: "translate(-3.000000, -228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Information",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telephones-icon",
    transform: "translate(3.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41158462,0.731296875 C4.41158462,0.091765625 4.18266154,0.091765625 3.83912308,0.091765625 C3.49558462,0.091765625 2.86604615,0.208015625 2.57973846,0.266140625 C2.29343077,0.324421875 1.09127692,1.02207812 0.747892308,1.31270312 C0.404507692,1.60348437 0.404507692,1.66160937 0.232661538,2.18489062 C0.0609692308,2.70801562 -0.797646154,8.40567187 2.40804615,13.4056719 C5.61373846,18.4056719 9.33466154,19.8009844 10.0788154,19.9173906 C10.8229692,20.0336406 10.8878923,20.0212969 11.1951231,19.9173906 C11.5385077,19.8009844 12.3015846,19.6633281 13.1128154,18.9289531 C13.7711231,18.3330156 13.7711231,17.9697344 13.8391231,17.7661406 C13.9054308,17.5677031 13.9714308,17.3009844 13.6280462,17.0103594 C13.2845077,16.7197344 10.4795846,14.3359844 10.1932769,14.0452031 C9.90712308,13.7545781 9.27743077,13.6381719 9.10558462,13.8127031 C8.93389231,13.9870781 8.3042,14.8591094 7.96081538,14.8591094 C7.61727692,14.8591094 6.98758462,14.8591094 6.70143077,14.6266094 C6.41512308,14.3941094 4.92681538,12.9987969 4.12543077,11.4289531 C3.32389231,9.85910937 2.86604615,8.40567187 2.92327692,7.99879687 C2.98050769,7.59176562 3.09496923,6.77785938 3.72466154,6.54520312 C4.35435385,6.31270312 4.58327692,6.31270312 4.86958462,6.19645312 C5.15573846,6.08020312 5.2702,6.02207812 5.21296923,5.44067187 C5.15573846,4.85926562 4.41158462,0.731296875 4.41158462,0.731296875",
    id: "Fill-1",
    fill: "#00AD50",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41158462,0.731296875 C4.41158462,0.091765625 4.18266154,0.091765625 3.83912308,0.091765625 C3.49558462,0.091765625 2.86604615,0.208015625 2.57973846,0.266140625 C2.29343077,0.324421875 1.09127692,1.02207812 0.747892308,1.31270312 C0.404507692,1.60348437 0.404507692,1.66160937 0.232661538,2.18489062 C0.0609692308,2.70801562 -0.797646154,8.40567187 2.40804615,13.4056719 C5.61373846,18.4056719 9.33466154,19.8009844 10.0788154,19.9173906 C10.8229692,20.0336406 10.8878923,20.0212969 11.1951231,19.9173906 C11.5385077,19.8009844 12.3015846,19.6633281 13.1128154,18.9289531 C13.7711231,18.3330156 13.7711231,17.9697344 13.8391231,17.7661406 C13.9054308,17.5677031 13.9714308,17.3009844 13.6280462,17.0103594 C13.2845077,16.7197344 10.4795846,14.3359844 10.1932769,14.0452031 C9.90712308,13.7545781 9.27743077,13.6381719 9.10558462,13.8127031 C8.93389231,13.9870781 8.3042,14.8591094 7.96081538,14.8591094 C7.61727692,14.8591094 6.98758462,14.8591094 6.70143077,14.6266094 C6.41512308,14.3941094 4.92681538,12.9987969 4.12543077,11.4289531 C3.32389231,9.85910937 2.86604615,8.40567187 2.92327692,7.99879687 C2.98050769,7.59176562 3.09496923,6.77785938 3.72466154,6.54520312 C4.35435385,6.31270312 4.58327692,6.31270312 4.86958462,6.19645312 C5.15573846,6.08020312 5.2702,6.02207812 5.21296923,5.44067187 C5.15573846,4.85926562 4.41158462,0.731296875 4.41158462,0.731296875",
    id: "Fill-4",
    fill: "#00AD50",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#00AD50",
    points: "19 8 7 8 11.0659349 4 12.1786459 5.09466677 10.7992053 6.45189256 19 6.45189256"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#00AD50",
    points: "16.9340651 14 15.8213541 12.9053332 17.2007947 11.5481074 9 11.5481074 9 10 21 10"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallPatient);
export default __webpack_public_path__ + "static/media/callPatient.3e21e14fccedd191b5315d96291bb469.svg";
export { ForwardRef as ReactComponent };